import './Corporate_gifts.scss';
import {PageManager} from '@mvps-genesis/core';
import customCarousel from 'Extensions/custom-carousel';
import 'Plugins/jquery.smartTabs.min.js';

/* eslint-disable max-lines-per-function, sort-keys, no-invalid-this */

export default class Corporate_gifts extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {
		const self = this;

		self.corporateGiftsSlider();

		customCarousel('.corp-engraving--left---carousel', {
			prevArrow: '.corp-engraving--left--prev',
			nextArrow: '.corp-engraving--left--next',
			draggable: true,
			fade: true,
			slidesToScroll: 1,
			slidesToShow: 1
		});

		$('#js-smart-tabs--accordion').smartTabs({
			layout: 'accordion'
		});
	}

	/* Product listing exists but is not referenced in the template code */
	corporateGiftsSlider () {
		if ($('.corp-featured--carousel').length) {
			// Settings
			const carouselOptions = {
				draggable: false,
				slidesPerRow: 2,
				rows: 2,
				responsive: [
					{
						breakpoint: 960,
						settings: {
							slidesPerRow: 3,
							rows: 2,
							centerMode: false
						}
					}
				]
			};
			const mobileOptions = {
				draggable: false,
				slidesToScroll: 1,
				slidesToShow: 1,
				centerMode: true,
				infinite: true,
				slide: '.category-product'
			};

			// Mobile
			$('.corp-featured--right').each(function () {
				const $mobileContainer = $(this).find('.mobile-featured-carousel');
				const $parentContainer = $(this);

				$parentContainer.find('.category-product').each(function () {
					const $slideElement = $(this).clone();
					$mobileContainer.append($slideElement);
				});

				customCarousel($mobileContainer, mobileOptions);
			});

			customCarousel('.corp-featured--carousel', carouselOptions);
		}
	}
}
